import { Routes, Route } from 'react-router-dom'
import { ProtectedRoute } from './ProtectedRoute'
import { AdminRoute } from './AdminRoute'

// Layouts
import MainLayout from '@/layouts/MainLayout'
import GameLayout from '@/layouts/GameLayout'
import AuthLayout from '@/layouts/AuthLayout'
import AdminLayout from '@/layouts/AdminLayout'

// Pages
import Landing from '@/pages/Landing'
import Lobby from '@/pages/Lobby'
import Game from '@/pages/Game'
import Profile from '@/pages/Profile'

// Admin Pages
import AdminDashboard from '@/pages/admin/Dashboard'
import AdminUsers from '@/pages/admin/Users'
import AdminDeposits from '@/pages/admin/Deposits'
import AdminWithdrawals from '@/pages/admin/Withdrawals'
import AdminCodes from '@/pages/admin/Codes'
import AdminKyc from '@/pages/admin/Kyc'
import AdminConfig from '@/pages/admin/Config'

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Landing />} />

      {/* Auth layout routes */}
      <Route element={<AuthLayout />}>
        {/* Add login/register pages here when implementing Phase 4 */}
      </Route>

      {/* Protected routes with MainLayout */}
      <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
        <Route path="/lobby" element={<Lobby />} />
        <Route path="/profile" element={<Profile />} />
      </Route>

      {/* Game routes with GameLayout */}
      <Route element={<ProtectedRoute><GameLayout /></ProtectedRoute>}>
        <Route path="/game/:gameId" element={<Game />} />
      </Route>

      {/* Admin routes */}
      <Route element={<AdminRoute><AdminLayout /></AdminRoute>}>
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/deposits" element={<AdminDeposits />} />
        <Route path="/admin/withdrawals" element={<AdminWithdrawals />} />
        <Route path="/admin/codes" element={<AdminCodes />} />
        <Route path="/admin/kyc" element={<AdminKyc />} />
        <Route path="/admin/config" element={<AdminConfig />} />
      </Route>
    </Routes>
  )
}
